import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as Chart from 'chart.js';
import * as jsPDF from 'jspdf';
import { Observable } from 'rxjs';
import { RestService } from '../rest.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { UserService } from '../user.service';

@Component({
  selector: 'app-direccion',
  templateUrl: './direccion.component.html',
  styleUrls: ['./direccion.component.scss']
})
export class DireccionComponent implements OnInit {

  @ViewChild('content',{static: false}) content: ElementRef;

  private intervalUpdate: any = null;
  chart1; chart2; chart3; chart4; chart5; chart6; chart7; chart8; chart9; chart10; chart11;

  items: Array<any> = [];
  date: string = this.user.formatDateES(new Date());
  date_comparativa: string = this.user.formatDateES(new Date());
  point: any = [];

  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'd-m-Y',
    defaultDate : this.date,
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.date = dateStr
  };

  dateTime2: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'd-m-Y',
    defaultDate : this.date,
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.date_comparativa = dateStr
  };

  constructor(
    public rest: RestService,
    public user: UserService
  ) { this.getPoints(); }

  ngOnInit() {
    this.chart1 = this.mixedChart('mix1', 'Navas-Bingo Electronico');
    this.chart2 = this.mixedChart('mix2', 'Riscal-Bingo Electronico');
    this.chart3 = this.mixedChart('mix3', 'Gorrion-Bingo Electronico');
    this.chart4 = this.mixedChart('mix4', 'Costablanca-Bingo Electronico');
    this.chart5 = this.mixedChart('mix5', 'Libertad-Bingo Electronico');
    this.chart6 = this.mixedChart('mix6', 'Central-Bingo Electronico');
    this.chart7 = this.mixedChart('mix7', 'Santa Pola-Bingo Electronico');
    this.chart8 = this.mixedChart('mix8', 'Goya-Bingo Electronico');
    this.chart9 = this.mixedChart('mix9', 'Carolinas-Bingo Electronico');
    /*this.chart10 = this.mixedChart('mix10', 'Plaza Gandia-Bingo Electronico');
    this.chart11 = this.mixedChart('mix11', 'Plaza Torrent-Bingo Electronico');*/
    this.getPoints();
    this.intervalUpdate = setInterval(function () { this.getPoints(); }.bind(this), 900000);
  }

  private mixedChart(nombre, textTitle) {
    return new Chart(document.getElementById(nombre), {
      type: 'bar',
      data: {
        labels: [],
        datasets: [
          {
            label: 'Zitro-Jugado',
            type: 'line',
            borderColor: '#e2001a',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'Zitro-Acumulado',
            type: 'line',
            borderColor: '#e2001a',
            data: [],
            fill: false,
            hidden: false
          },
          {
            label: 'ZitroAA-Jugado',
            type: 'line',
            borderColor: 'tomato',
            data: [],
            fill: false,
            hidden: true
          },
          {
            label: 'ZitroAA-Acumulado',
            type: 'line',
            borderColor: 'tomato',
            data: [],
            fill: false,
            hidden: false
          },
          {
            label: 'Azul-Jugado',
            type: 'line',
            borderColor: '#0071bc',
            data: [],
            fill: false,
            hidden: true
          },
          {
            label: 'Azul-Acumulado',
            type: 'line',
            borderColor: '#0071bc',
            data: [],
            fill: false,
            hidden: false
          },
          {
            label: 'AzulAA-Jugado',
            type: 'line',
            borderColor: '#4b96c7',
            data: [],
            fill: false,
            hidden: true
          },
          {
            label: 'AzulAA-Acumulado',
            type: 'line',
            borderColor: '#4b96c7',
            data: [],
            fill: false,
            hidden: true
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: textTitle
        },
        scales: {
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true
            },
            ticks: {
              beginAtZero: true
              // steps: 10,
              // stepValue: 1500
              // max: 10000
            }
          }]
        },
        events: ['click'],
        legend: { display: true },
        maintainAspectRatio: true,
        responsive: true
      }
    });
  }

  restAux(chart, sala, operador, fecha, index1, index2) {

    this.rest.getKPI(sala, operador, fecha).subscribe((data) => {
      const label: any = [];
      const data1: any = [];
      const data2: any = [];

      for (let index = 0; index < data['data'].length; index++) {
        label.push(data['data'][index]['rango']);
        data1.push(data['data'][index]['jugado']);

        if (index > 0 && data['data'][index]['acumulado'] < 0.01) {
          data['data'][index]['acumulado'] = data['data'][index - 1]['acumulado'];
          data2.push(data['data'][index]['acumulado']);
        } else {
          data2.push(data['data'][index]['acumulado']);
        }
      }

      chart.data.labels = label;
      chart.data.datasets[index1].data = data1;
      chart.data.datasets[index2].data = data2;
      chart.update();
    });
  }

  getPoints() {

    this.restAux(this.chart1, 21, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart1, 21, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart1, 21, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart1, 21, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart2, 17, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart2, 17, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart2, 17, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart2, 17, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart3, 22, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart3, 22, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart3, 22, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart3, 22, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart4, 20, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart4, 20, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart4, 20, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart4, 20, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart5, 1, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart5, 1, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart5, 1, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart5, 1, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart6, 2, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart6, 2, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart6, 2, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart6, 2, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart7, 3, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart7, 3, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart7, 3, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart7, 3, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart8, 4, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart8, 4, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart8, 4, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart8, 4, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart9, 5, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart9, 5, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart9, 5, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart9, 5, 'DEGESTEC', this.date_comparativa, 6, 7);

    /*this.restAux(this.chart10, 6, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart10, 6, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart10, 6, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart10, 6, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart11, 7, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart11, 7, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart11, 7, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart11, 7, 'DEGESTEC', this.date_comparativa, 6, 7);*/
  }

  destroyAndBuild() {
    if (this.chart1) { this.chart1.destroy(); }
    if (this.chart2) { this.chart2.destroy(); }
    if (this.chart3) { this.chart3.destroy(); }
    if (this.chart4) { this.chart4.destroy(); }
    if (this.chart5) { this.chart5.destroy(); }
    if (this.chart6) { this.chart6.destroy(); }
    if (this.chart7) { this.chart7.destroy(); }
    if (this.chart8) { this.chart8.destroy(); }
    if (this.chart9) { this.chart9.destroy(); }
    /*if (this.chart10) { this.chart10.destroy(); }
    if (this.chart11) { this.chart11.destroy(); }*/
    this.chart1 = this.mixedChart('mix1', 'Navas');
    this.chart2 = this.mixedChart('mix2', 'Riscal');
    this.chart3 = this.mixedChart('mix3', 'Gorrion');
    this.chart4 = this.mixedChart('mix4', 'Costablanca');
    this.chart5 = this.mixedChart('mix5', 'Libertad');
    this.chart6 = this.mixedChart('mix6', 'Central');
    this.chart7 = this.mixedChart('mix7', 'Santa Pola');
    this.chart8 = this.mixedChart('mix8', 'Goya');
    this.chart9 = this.mixedChart('mix9', 'Carolinas');
    /*this.chart10 = this.mixedChart('mix10', 'Plaza Gandia');
    this.chart11 = this.mixedChart('mix11', 'Plaza Torrent');*/
    this.getPoints();
  }



}
